import { GtmParams } from '../types';

const callGtmEvent = (eventName: string, params: GtmParams): void => {
  if (window.gtag) {
    try {
      window.gtag('event', eventName, params);
    } catch (error) {
      console.log('gtag error', error);
    }
  }
};

export default callGtmEvent;
